/* eslint-disable */
import React from "react";

const ExpandIcon = () => (
  <svg width="34px" height="34px" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <title>C21D18F7-A681-4F00-835C-6276A54CC071</title>
    <g id="Checkout-Flow---Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="PDP---Checkout---Shipping" transform="translate(-765.000000, -873.000000)">
            <g id="expand-btn" transform="translate(766.000000, 874.000000)">
                <path d="M0,0 L32,0 L32,32 L0,32 L0,0 Z" id="expand-btn-(Background)"></path>
                <g id="Group-4-Copy" stroke="#242636" strokeDasharray="0,0">
                    <line x1="15.9999807" y1="10.3157895" x2="15.9999807" y2="21.6842108" id="Line-2" fillRule="nonzero"></line>
                    <line x1="21.6842108" y1="16.0001028" x2="10.3157895" y2="16.0001028" id="Line-2" fillRule="nonzero"></line>
                    <path d="M16,32 C24.836556,32 32,24.836556 32,16 C32,7.163444 24.836556,0 16,0 C7.163444,0 0,7.163444 0,16 C0,24.836556 7.163444,32 16,32 Z" id="Oval-2"></path>
                </g>
            </g>
        </g>
    </g>
  </svg>
);

export default ExpandIcon;
